import React from 'react';
import PropTypes from 'prop-types';

const PartsListAdded = props => (
  <div className="parts-list" id="parts-list-added">
    <div className="parts-title parts-list-added-msg">
      <i className="table-cell icon icon-rs_57-tick" aria-hidden="true" />
      <span>{props.successMessage}</span>
    </div>
    <div className="product table">
      <span className="added-quantity table-cell">{props.addedQuantity}</span>
      <div className="product-details table-cell">
        <div>{props.name}</div>
        <div className="rsStockNumberDiv">
          <span>{props.stockNumber}</span>
        </div>
        <div className="mpnNumberDiv">
          <span>{props.manufacturerPartNumber}</span>
        </div>
      </div>
    </div>
    <hr />
    <div className="buttons">
      <button className="btn btn-default" onClick={props.closeModal}>{props.labels.close}</button>&nbsp;
      <a href={props.partsListDetailsUrl} className="btn btn-secondary-blue btn-view-parts-list">{props.labels.viewList}</a>
    </div>
  </div>
);

PartsListAdded.propTypes = {
  name: PropTypes.string,
  stockNumber: PropTypes.string,
  manufacturerPartNumber: PropTypes.string,
  labels: PropTypes.shape({
    addedToPartsList: PropTypes.string,
    close: PropTypes.string,
    viewList: PropTypes.string,
  }),
  successMessage: PropTypes.string,
  addedQuantity: PropTypes.number,
  closeModal: PropTypes.func,
  partsListDetailsUrl: PropTypes.string,
};

PartsListAdded.defaultProps = {
  name: '',
  stockNumber: '',
  manufacturerPartNumber: '',
  labels: {},
  successMessage: null,
  addedQuantity: null,
  closeModal: null,
  viewList: null,
  partsListDetailsUrl: null,
};

export default PartsListAdded;



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/components/PartsList/PartsListAdded.js